import { http } from '../../util/http';

export default class VehicleAdService {
	static get(page, pageLimit, type = 'used') {
		return http.get(`/vehicles/car/${type}?page=${page}&pageLimit=${pageLimit}`);
	}

	static search(type, query, user, featured) {
		return http.get(`/vehicles/car/${type}/search?q=${query}&user=${user}&featured=${featured}`);
	}

	static add(body) {
		return http.post('/vehicles/car/used', body);
	}

	static update(id, body) {
		return http.patch(`/vehicles/${id}`, body);
	}

	static updateStatus(id, body) {
		return http.patch(`/vehicles/${id}/status`, body);
	}

	static updateFeatureStatus(id, body) {
		return http.post(`/vehicles/${id}/featured`, body);
	}

	static delete(id) {
		return http.delete(`/vehicles/${id}`);
	}
}
